import { useEffect } from 'react'
import {
  Box, Container, Typography,
} from '@mui/material'
import CookiesStorageService from '../../../services/CookiesStorageService'
import UseTranslation from '../../../hooks/UseTranslation'
import DisabledUserImg from '../../../images/DisabledUser.svg'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'

const DisabledUser = () => {
  const umFrontEndPath = '/'
  const { t } = UseTranslation()

  useEffect(() => {
    CookiesStorageService.clearCookies()
  }, [])

  const redirectToAuthPage = () => {
    window.location.href = `${umFrontEndPath}`
  }

  return (
    <Box sx={styles.root}>
      <Container maxWidth='xl' sx={styles.container}>
        <Box sx={styles.textWrapper}>
          <Typography sx={styles.errorTitle} variant="h1">
            {t?.['Account Disabled']}
          </Typography>
          <Typography variant="h3" sx={styles.errorSubTitle}>
            {t?.['Sorry but your user has been disabled.']}
          </Typography>
          <Typography variant="p" sx={styles.errorDescription}>
            {t?.['Please contact your System Administrator for assistance. If you believe this is an error, reach out to your organization support team.']}
          </Typography>
          <OfoqThemeBtn
          customStyle={styles.requestBtn}
          name={t?.['Move to Login Screen']}
          onClick={redirectToAuthPage}
        />
        </Box>
        <Box component="img" src={DisabledUserImg} sx={styles.image} />
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    paddingTop: '-80px',
    scrollY: 'hidden',
  },
  container: {
    display: 'flex',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    justifyContent: { xs: 'center', md: 'space-between' },
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', md: 'flex-start' },
    padding: { xs: '20px 10px 0 10px', md: '100px 0 0 21px', lg: '100px 0 0 80px' },
    maxWidth: { xs: '100%', md: '670px' },
  },
  errorTitle: {
    color: 'primary.main',
    fontSize: { xs: '20px', sm: '30px', md: '60px' },
    lineHeight: '60px',
  },
  errorSubTitle: {
    fontSize: { xs: '14px', sm: '18px', md: '22px' },
    lineHeight: '25px',
    paddingTop: { xs: '20px', md: '45px' },
    textAlign: { xs: 'center', sm: 'left' },
  },
  errorDescription: {
    fontSize: { xs: '12px', sm: '16px', md: '18px' },
    lineHeight: { xs: '20px', sm: '43px' },
    paddingTop: { xs: '10px', md: '30px' },
    color: '#92929D',
    textAlign: { xs: 'center', sm: 'left' },
    fontWeight: 200,
  },
  image: {
    maxWidth: { xs: '200px', sm: '700px' },
    maxHeight: { xs: '200px', sm: '700px' },
    marginInline: 'auto',
    marginTop: { xs: '0px', md: '30px' },
  },
  requestBtn: {
    fontSize: { xs: '14px', sm: '16px' },
    maxWidth: { xs: '200px', md: '318px' },
    marginTop: { xs: '30px', md: '30px' },
    color: 'white',
    marginInline: { xs: 'auto', md: '0' },
    px: { xs: 3, md: 5 },
    textTransform: 'none',
  },
}
export default DisabledUser
